import React from 'react';
import {Link} from 'react-router-dom';
import "./styles.scss";
import classNames from "classnames";

export interface ITableRowProps {
  link?: string | null | undefined,
  onClick?: () => void,
  style?: {},
  className?: string,
}

const TableRow: React.FC<ITableRowProps> = ({children, link, onClick, style = {}, className}) => {
  if (!!link) {
    return (
      <Link to={link}
            target="_blank"
            style={style}
            className={classNames('table__row', className)}>
        {children}
      </Link>
    );
  }

  if(!onClick) {
    return (
        <div className={classNames('table__row', className)} style={style}>
          {children}
        </div>
    )
  }

  const onClickButton = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.persist();
      event.preventDefault();

      onClick();
  };

  return (
    <a href={"/#"} onClick={onClickButton} className={classNames('table__row', className)} style={style}>
      {children}
    </a>
  )
};

export default TableRow;
